import { createFileRoute } from '@tanstack/react-router';
import { AssetTable } from '../../features/assets/components/asset-table';

export const Route = createFileRoute('/_creator-center/avatars/')({
  component: AssetsIndex,
});

function AssetsIndex() {
  return <AssetTable />;
}
